<template>
  <div>
    <!-- Overview Cards -->
    <a-row :gutter="[24, 24]" style="margin-bottom: 24px">
      <a-col :span="6">
        <a-card
          :bodyStyle="{
            height: '120px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }"
          style="border-radius: 8px"
          :bordered="true"
        >
          <div style="font-weight: 600; font-size: 14px">
            Total Consignments (This Month)
          </div>
          <div
            style="
              font-size: 18px;
              font-weight: 700;
              color: #26a246;
              margin-top: 8px;
            "
          >
            {{ consignmentStats.totalConsignmentsThisMonth}}
          </div>
        </a-card>
      </a-col>
      <a-col :span="6">
        <a-card
          :bodyStyle="{
            height: '120px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }"
          style="border-radius: 8px"
          :bordered="true"
        >
          <div style="font-weight: 600; font-size: 14px">
            Avg. Sell-Through (Last 30 Days)
          </div>
          <div
            style="
              font-size: 18px;
              font-weight: 700;
              color: #26a246;
              margin-top: 8px;
            "
          >
            {{ consignmentStats.avgSellThroughLast30Days }}
          </div>
        </a-card>
      </a-col>
      <a-col :span="6">
        <a-card
          :bodyStyle="{
            height: '120px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }"
          style="border-radius: 8px"
          :bordered="true"
        >
          <div style="font-weight: 600; font-size: 14px">
            Total Value of Consigned Stock
          </div>
          <div
            style="
              font-size: 18px;
              font-weight: 700;
              color: #26a246;
              margin-top: 8px;
            "
          >
            {{ formatAmount(consignmentStats.totalValueOfConsignedStock) }}
          </div>
        </a-card>
      </a-col>
      <a-col :span="6">
        <a-card
          :bodyStyle="{
            height: '120px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }"
          style="border-radius: 8px"
          :bordered="true"
        >
          <div style="font-weight: 600; font-size: 14px">
            Stock Still Remaining
          </div>
          <div
            style="
              font-size: 18px;
              font-weight: 700;
              color: #26a246;
              margin-top: 8px;
            "
          >
            {{ consignmentStats.stockStillRemaining.toLocaleString() }}
          </div>
        </a-card>
      </a-col>
    </a-row>
    <!-- Search and Filter Section -->
    <a-row :gutter="[16, 16]" style="margin-bottom: 16px">
      <a-col :span="12">
        <p style="margin: 0px">Search</p>
        <a-input-search
          placeholder="Search by consignment ID or warehouse"
          style="width: 100%"
          v-model="filters.search"
        />
      </a-col>
      <a-col :span="6">
        <p style="margin: 0px">Status</p>
        <a-select
          defaultValue="All"
          style="width: 100%"
          v-model="filters.status"
        >
          <a-select-option
            v-for="status in statusOptions"
            :key="status.value"
            :value="status.value"
            >{{ status.label }}</a-select-option
          >
        </a-select>
      </a-col>
    </a-row>
    <EmptyState
      v-if="consignmentOrders.length === 0 && !loadingConsignments"
      icon="fa-inbox"
      title="No consignment orders found"
      description="Consignment orders will appear here when available."
      :hasActiveFilter="Object.values(filters).some((filter) => filter)"
    />

    <a-table
      v-else
      :data-source="consignmentOrders"
      :loading="loadingConsignments"
      rowKey="id"
      :scroll="{ x: 'max-content' }"
      :pagination="tablePagination"
      @change="handleTableChange"
      style="background: #fff; margin-top: 16px"
    >
      <a-table-column
        title="Consignment ID"
        dataIndex="consignmentId"
        key="consignmentId"
      />
      <a-table-column title="Warehouse" dataIndex="warehouse" key="warehouse" />
      <a-table-column
        title="Quantity"
        dataIndex="totalQuantity"
        key="totalQuantity"
      />
      <a-table-column
        title="Date Sent"
        key="createdAt"
        :customRender="(text, record) => formatDate(record.createdAt)"
      />
      <a-table-column
        title="Delivery Date"
        key="delvieryDate"
        :customRender="(text, record) => formatDate(record.delvieryDate)"
      />
      <a-table-column
        title="Total Stock Consigned"
        dataIndex="totalQuantity"
        key="totalStockConsigned"
      />
      <a-table-column
        title="Value of Stock Consigned"
        key="totalValue"
        :customRender="(text, record) => formatAmount(record.totalValue)"
      />
      <a-table-column
        title="Stock Sold"
        dataIndex="stockSold"
        key="stockSold"
      />
      <a-table-column
        title="Available Stock"
        dataIndex="availableStock"
        key="availableStock"
      />
      <!-- <a-table-column
        title="Value of Outstanding Stock"
        key="outstandingValue"
        :customRender="
          (text, record) =>
            `GHS ${
              record.outstandingValue
                ? record.outstandingValue.toLocaleString()
                : '0'
            }`
        "
      /> -->
      <a-table-column title="Status" key="status">
        <template slot-scope="text, record">
          <StatusTag :status="record.status" />
        </template>
      </a-table-column>
      <a-table-column title="Actions" key="actions">
        <template slot-scope="text, record">
          <a-button type="link" @click="handleView(record)">
            <i class="fa fa-eye" style="color: #9e9e9e" aria-hidden="true"></i>
          </a-button>
        </template>
      </a-table-column>
    </a-table>
  </div>
</template>

<script>
import sellersService from "../../../api/sellers.service";
import { formatDate } from "../../../utils";
import StatusTag from "../../shared-components/StatusTag.vue";
import EmptyState from "../../shared-components/EmptyState.vue";
import { formatAmount } from "../../../utils";

export default {
  name: "ConsignmentOrders",
  components: { StatusTag, EmptyState },
  props: {
    sellerId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      consignmentOrders: [],
      loadingConsignments: false,
      consignmentStats: {
        totalConsignmentsThisMonth: 0,
        avgSellThroughLast30Days: 0,
        totalValueOfConsignedStock: 0,
        stockStillRemaining: 0,
      },
      filters: {
        search: null,
        status: null,
      },
      statusOptions: [
        { label: "All", value: null },
        { label: "Pending", value: "Pending" },
        { label: "Delivered", value: "Delivered" },
      ],
      searchDebounceTimer: null,
      pagination: {
        pageIndex: 1,
        pageSize: 10,
        totalCount: 0,
      },
    };
  },
  computed: {
    tablePagination() {
      return {
        current: this.pagination.pageIndex,
        pageSize: this.pagination.pageSize,
        total: this.pagination.totalCount,
        showTotal: (total, range) =>
          `${range[0]}-${range[1]} of ${total} consignments`,
        showSizeChanger: false,
      };
    },
  },
  watch: {
    "filters.search"() {
      if (this.searchDebounceTimer) clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = setTimeout(() => {
        this.pagination.pageIndex = 1;
        this.fetchConsignmentOrders();
      }, 400);
    },
    "filters.status"() {
      this.pagination.pageIndex = 1;
      this.fetchConsignmentOrders();
    },
    "pagination.pageIndex"() {
      this.fetchConsignmentOrders();
    },
  },
  created() {
    this.fetchConsignmentStats();
    this.fetchConsignmentOrders();
  },
  methods: {
    formatAmount,
    async fetchConsignmentStats() {
      const response = await sellersService.getSellerConsignmentStats(
        this.sellerId
      );
      if (response && response.status === 200) {
        this.consignmentStats = response.data?.data || {
          totalConsignmentsThisMonth: 0,
          avgSellThroughLast30Days: 0,
          totalValueOfConsignedStock: 0,
          stockStillRemaining: 0,
        };
      } else {
        this.consignmentStats = {
          totalConsignmentsThisMonth: 0,
          avgSellThroughLast30Days: 0,
          totalValueOfConsignedStock: 0,
          stockStillRemaining: 0,
        };
        this.$message.error(
          response?.data?.message || "An error occurred while fetching stats"
        );
      }
    },
    async fetchConsignmentOrders() {
      this.loadingConsignments = true;
      const response = await sellersService.getSellerConsignmentOrders(
        this.sellerId,
        {
          ...this.filters,
          pageIndex: this.pagination.pageIndex,
          pageSize: this.pagination.pageSize,
        }
      );
      if (response && response.status === 200) {
        const data = response.data?.data || {};
        this.consignmentOrders = data.results || [];
        this.pagination.totalCount = data.totalCount || 0;
        this.pagination.pageIndex = data.pageIndex || this.pagination.pageIndex;
      } else {
        this.$message.error(
          response?.data?.message || "Failed to fetch consignment orders."
        );
        this.consignmentOrders = [];
        this.pagination.totalCount = 0;
      }
      this.loadingConsignments = false;
    },
    handleTableChange(pagination) {
      if (pagination.current !== this.pagination.pageIndex) {
        this.pagination.pageIndex = pagination.current;
      }
    },
    formatDate,
    handleView(record) {
      console.log("Viewing:", record);
      // Navigate to the new ConsignmentDetails route
      if (record.id) {
        this.$router.push({
          name: "ConsignmentDetails",
          params: {
            userId: this.sellerId,
            consignmentId: record.id,
          },
        });
      } else {
        console.warn(
          "Consignment ID (internal ID) not found for view action:",
          record
        );
      }
    },
  },
};
</script>

<style scoped></style>
